<template>
    <u-dialog v-model="shows" title="신청내역상세" width="1200" max-width="90%">
        <template #activator="{ attrs, on }">
            <slot name="activator" v-bind="{ attrs, on }" />
        </template>
        <v-tabs-items v-model="tab" touchless>
            <v-tab-item value="view">
                <form-view v-model="form" v-bind="props_form" ref="view" />
                <div class="btn-wrap btn-wrap--lg" v-if="isEditable">
                    <v-row justify="center" class="row--xs">
                        <v-col cols="6" sm="auto">
                            <btn-secondary-2 x-large class="w-100 min-w-sm-160px" @click="tab = 'delt'">신청취소</btn-secondary-2>
                        </v-col>
                        <v-col cols="6" sm="auto">
                            <btn-primary-2 x-large class="w-100 min-w-sm-160px" @click="tab = 'form'">신청수정</btn-primary-2>
                        </v-col>
                    </v-row>
                </div>
            </v-tab-item>
            <v-tab-item value="form">
                <form-input v-bind="props_form" ref="form" @prev="tab = 'view'" />
            </v-tab-item>
            <v-tab-item value="delt">
                <form-remove v-bind="props_form" ref="delt" @prev="tab = 'view'" />
            </v-tab-item>
        </v-tabs-items>
    </u-dialog>
</template>

<script>
import { APPLICATION_STATUS } from "@/assets/variables";

import UDialog from "@/components/dumb/u-dialog.vue";
import BtnPrimary from "@/components/publish/parents/buttons/btn-primary.vue";
import BtnPrimary2 from "@/components/publish/parents/buttons/btn-primary2.vue";
import BtnSecondary from "@/components/publish/parents/buttons/btn-secondary.vue";
import BtnSecondary2 from "@/components/publish/parents/buttons/btn-secondary2.vue";

import FormView from "../form/form-view.vue";
import FormInput from "../form/form-input.vue";
import FormRemove from "../form/form-remove.vue";

export default {
    components: {
        UDialog,
        BtnPrimary,
        BtnPrimary2,
        BtnSecondary,
        BtnSecondary2,

        FormView,
        FormInput,
        FormRemove,
    },
    props: {
        value: { type: Object, default: () => ({}) },
    },
    setup: () => ({}),
    data: () => ({
        form: undefined,

        tab: "view",
        shows: false,
    }),
    computed: {
        isEditable() {
            return this.form?.status === APPLICATION_STATUS.WAITING.value;
        },
        props_form() {
            return {
                _form: this.value?._id,
                code: "studio-apply",
                skin: "studio-apply",
            };
        },
    },
    methods: {
        init() {
            this.tab = "view";
        },
    },
    watch: {
        tab(tab) {
            this.$refs[tab]?.init?.();
        },
        shows() {
            if (this.shows) this.tab = "view";
        },
    },
    mounted() {
        this.init();
    },
    beforeUnmount() {},
};
</script>

<style lang="scss" scoped></style>
